import React from 'react'
import { MarketViewVendor, MarketViewProduct, MarketViewScores } from '../../services/api'
import ScoreRadarChart from './ScoreRadarChart'
import { Building2, ExternalLink } from 'lucide-react'

interface VendorMapPopupProps {
  vendor: MarketViewVendor
  product: MarketViewProduct
  scores: MarketViewScores
}

const VendorMapPopup: React.FC<VendorMapPopupProps> = ({ vendor, product, scores }) => {
  const imageUrl = product.primary_image?.image_url || product.image_url

  return (
    <div className="w-72">
      {/* Product Image */}
      <div className="h-32 bg-muted rounded mb-3">
        {imageUrl ? (
          <img src={imageUrl} alt={product.name} className="w-full h-full object-cover rounded" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Building2 className="w-12 h-12 text-muted-foreground/30" />
          </div>
        )}
      </div>

      {/* Product & Vendor Info */}
      <h4 className="font-semibold text-sm mb-1">{product.name}</h4>
      <p className="text-xs text-muted-foreground mb-2">{vendor.name}</p>
      <p className="text-xs text-muted-foreground mb-3">
        {vendor.headquarters_location || 'Location unknown'}
      </p>

      {/* Description */}
      <p className="text-xs text-muted-foreground line-clamp-3 mb-3">
        {product.description || 'No description available'}
      </p>

      {/* Radar Chart */}
      <div className="flex justify-center mb-3">
        <ScoreRadarChart scores={scores} size={140} />
      </div>

      {/* Links */}
      {product.product_url && (
        <a
          href={product.product_url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-primary hover:text-primary/80 flex items-center gap-1"
        >
          Product page
          <ExternalLink className="w-3 h-3" />
        </a>
      )}
    </div>
  )
}

export default VendorMapPopup
